import Superstore from '../../../superstore';

export default new Superstore.Models.Base({
    name: 'file',

    instance: {
        props: {
            name: {
                type: String,
                default() {
                    return 'Untitled';
                }
            },
            content: {
                type: String,
                default: ''
            }
        }
    }
});
